export const WORDS = [
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
  'monday',
  'tuesday',
  'aurora',
  'plains',
  'topeka',
  'wichita',
  'lawrence',
  'manhattan',
  'salina',
  'sunflower',
  'jayhawk',
  'kstate',
  'prairie',
  'tornado',
  'dodge',
  'hutch',
  'osage',
  'smoky',
  'cheyenne',
  'emporia',
  'olathe',
  'lenexa',
  'derby',
  'andover',
  'abilene',
  'ottawa',
  'parsons',
  'atchison',
  'seneca',
  'garden',
  'hays',
  'colby',
  'eureka',
  'mission',
  'bonner',
  'eldorado',
  'arkcity',
  'neodesha',
  'meade',
  'phillips',
  'clay',
  'fortscott',
  'junction',
  'medicine',
  'leaven',
  'mulvane',
  'larned',
  'oswego'
]